module.exports = __webpack_public_path__ + "static/media/recruitbannerbg@3x.a321278e.png";